import React from "react";
import { I2cInput } from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
const NewProgamForm = ({ control, handleValueChanges, methods, errors }) => {
  return (
    <div className="forms-instance section-space">
      <div className="sub-heading mb-4">Projection at Launch</div>
      <p className="custom-label-light mb-16">
        Estimated traffic for the first year.
      </p>
      <div className="custom-label mb-6">
        Estimated Count{" "}
        <span className="light-color">(Number of cards in service)</span>
        <sup>•</sup>
      </div>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_ecount_1"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q1 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_ecount_1"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_ecount_1 &&
                methods.formState.touchedFields.pi_ecount_1
                  ? true
                  : false
              }
              message={errors.pi_ecount_1?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_ecount_2"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q2 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_ecount_2"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_ecount_2 &&
                methods.formState.touchedFields.pi_ecount_2
                  ? true
                  : false
              }
              message={errors.pi_ecount_2?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_ecount_3"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q3 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_ecount_3"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_ecount_3 &&
                methods.formState.touchedFields.pi_ecount_3
                  ? true
                  : false
              }
              message={errors.pi_ecount_3?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_ecount_4"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q4 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_ecount_4"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_ecount_4 &&
                methods.formState.touchedFields.pi_ecount_4
                  ? true
                  : false
              }
              message={errors.pi_ecount_4?.message ?? "Invalid input"}
            />
          </div>
        </div>
      </div>
      <div className="custom-label mb-6 mt-16">
        Estimated Value <span className="light-color">(Transaction value)</span>
        <sup>•</sup>
      </div>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evalue_1"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q1 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evalue_1"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evalue_1 &&
                methods.formState.touchedFields.pi_evalue_1
                  ? true
                  : false
              }
              message={errors.pi_evalue_1?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evalue_2"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q2 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evalue_2"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evalue_2 &&
                methods.formState.touchedFields.pi_evalue_2
                  ? true
                  : false
              }
              message={errors.pi_evalue_2?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evalue_3"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q3 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evalue_3"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evalue_3 &&
                methods.formState.touchedFields.pi_evalue_3
                  ? true
                  : false
              }
              message={errors.pi_evalue_3?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evalue_4"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q4 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evalue_4"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evalue_4 &&
                methods.formState.touchedFields.pi_evalue_4
                  ? true
                  : false
              }
              message={errors.pi_evalue_4?.message ?? "Invalid input"}
            />
          </div>
        </div>
      </div>
      <div className="custom-label mb-6 mt-16">
        Estimated Volume
        <span className="light-color"> (Transaction volume)</span>
        <sup>•</sup>
      </div>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evolume_1"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q1 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evolume_1"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evolume_1 &&
                methods.formState.touchedFields.pi_evolume_1
                  ? true
                  : false
              }
              message={errors.pi_evolume_1?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evolume_2"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q2 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evolume_2"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evolume_2 &&
                methods.formState.touchedFields.pi_evolume_2
                  ? true
                  : false
              }
              message={errors.pi_evolume_2?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evolume_3"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q3 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evolume_3"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evolume_3 &&
                methods.formState.touchedFields.pi_evolume_3
                  ? true
                  : false
              }
              message={errors.pi_evolume_3?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div i2c-grid="6@sm 3@md">
          <div className="single-field-wrapper">
            <Controller
              name="pi_evolume_4"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Q4 estimate"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pi_evolume_4"}
                />
              )}
            />
            <ErrorMessage
              show={
                errors.pi_evolume_4 &&
                methods.formState.touchedFields.pi_evolume_4
                  ? true
                  : false
              }
              message={errors.pi_evolume_4?.message ?? "Invalid input"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProgamForm;
